import content from '../../../../redux/reducer/content';
import { useDispatch } from 'react-redux';

export default function useChallengesCallbacks() {
  const dispatch = useDispatch();

  return {
    setChallengesActiveTab: (activeTab) => dispatch(content.actions.setChallengesActiveTab(activeTab)),
    clearNewIcons: (data) => dispatch(content.actions.clearNewIcons(data)),
  };
}
